export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./events-list-item.vue?vue&type=template&id=37d2c11e&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/events-list/events-list-item.vue?vue&type=template&id=37d2c11e&
// module id = 947
// module chunks = 0